var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-con",on:{"click":_vm.showMessage}},[_c('el-badge',{staticClass:"item",attrs:{"value":_vm.mesCount?'new':''}},[_c('Icon',{attrs:{"type":"ios-bell","size":22}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }